const BurgerItem = ({ to, text }) => (
  <li className="burger__dropdown-item">
    <a href={to} target="_blank" rel="noreferrer">
      {text}
    </a>
  </li>
);

export default BurgerItem;
